!(function (t, e) {
  if ("object" == typeof exports && "object" == typeof module)
    module.exports = e();
  else if ("function" == typeof define && define.amd) define([], e);
  else {
    var i = e();
    for (var n in i) ("object" == typeof exports ? exports : t)[n] = i[n];
  }
})(window, function () {
  return (function (t) {
    var e = {};
    function i(n) {
      if (e[n]) return e[n].exports;
      var o = (e[n] = { i: n, l: !1, exports: {} });
      return t[n].call(o.exports, o, o.exports, i), (o.l = !0), o.exports;
    }
    return (
      (i.m = t),
      (i.c = e),
      (i.d = function (t, e, n) {
        i.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n });
      }),
      (i.r = function (t) {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(t, "__esModule", { value: !0 });
      }),
      (i.t = function (t, e) {
        if ((1 & e && (t = i(t)), 8 & e)) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (
          (i.r(n),
          Object.defineProperty(n, "default", { enumerable: !0, value: t }),
          2 & e && "string" != typeof t)
        )
          for (var o in t)
            i.d(
              n,
              o,
              function (e) {
                return t[e];
              }.bind(null, o)
            );
        return n;
      }),
      (i.n = function (t) {
        var e =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return i.d(e, "a", e), e;
      }),
      (i.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }),
      (i.p = "/"),
      i((i.s = 11))
    );
  })([
    function (t, e) {
      t.exports = require("jquery");
    },
    function (t, e, i) {
      "use strict";
      i.r(e);
      var n = i(0),
        o = i.n(n),
        s = (i(3), i(2)),
        r = "slideChange",
        l = "changeStart",
        a = "changeEnded",
        h = (function () {
          function t(t) {
            (this.config = {
              el: o()(),
              min: 0,
              max: 100,
              step: 1,
              value: 50,
              isRtl: !1,
            }),
              (this.isRtl = !1),
              (this.config = o.a.extend({}, this.config, t)),
              (this.$el = o()(this.config.el).eq(0)),
              (this.$eventEl = o()("<div />")),
              (this.$fill = o()('<div class="range-fill"></div>')),
              (this.$handle = o()('<button class="range-handle"></button>')),
              (this.rangeRectWidth = 0),
              (this.handleRectWidth = 0),
              (this.maxHandleLimitPositionLeft = 0),
              (this.centerOfHandle = 0),
              (this.positionLeft = 0),
              (this.randomClass = "range-" + Math.random().toString().slice(2)),
              (this.startEvent = ["mousedown", "touchstart"].join(
                "." + this.randomClass + " "
              )),
              (this.moveEvent = ["mousemove", "touchmove"].join(
                "." + this.randomClass + " "
              )),
              (this.endEvent = ["mouseup", "touchend"].join(
                "." + this.randomClass + " "
              )),
              (this.lastValue = -1),
              (this.isRtl = this.config.isRtl),
              this.init();
          }
          return (
            (t.prototype.init = function () {
              this.isRtl && this.$el.addClass("rtl"),
                this.$el.addClass("range").addClass(this.randomClass),
                this.$el.append(this.$fill, this.$handle),
                this.update_rect(),
                this.set_position_left(),
                this.event_handle();
            }),
            (t.prototype.update = function () {
              this.on_resize();
            }),
            (t.prototype.set_value = function (t, e) {
              return (
                void 0 === e && (e = !1),
                (t = e ? t * this.config.max : t),
                this.update_rect(),
                this.set_position_left(
                  this.get_position_left_by_value(t),
                  !1,
                  !0
                ),
                this
              );
            }),
            (t.prototype.destroy = function () {
              this.$eventEl.trigger("beforeDestroy"),
                this.$el.removeClass("range").removeClass(this.randomClass),
                this.$el.html(""),
                (this.$el = o()()),
                (this.$eventEl = o()()),
                (this.$fill = o()()),
                (this.$handle = o()()),
                o()(document).off(this.startEvent),
                o()(window).off("resize." + this.randomClass);
            }),
            (t.prototype.on = function (t, e) {
              return this.$eventEl.on(t, e), this;
            }),
            (t.prototype.one = function (t, e) {
              return this.$eventEl.one(t, e), this;
            }),
            (t.prototype.off = function (t) {
              return this.$eventEl.off(t), this;
            }),
            (t.prototype.event_handle = function () {
              var t = this;
              o()(document).on(
                this.startEvent,
                "." + this.randomClass,
                function (e) {
                  return t.$eventEl.trigger(l) && t.on_start_event_handle(e);
                }
              ),
                o()(window).on(
                  "resize." + this.randomClass,
                  Object(s.debounce)(this.on_resize.bind(this), 200)
                );
            }),
            (t.prototype.on_resize = function () {
              this.update_rect(), this.set_position_left(this.positionLeft, !0);
            }),
            (t.prototype.on_start_event_handle = function (t) {
              var e = this;
              t.preventDefault(),
                this.on_move_event_handle(t),
                o()(document)
                  .on(this.moveEvent, function (t) {
                    return e.on_move_event_handle(t);
                  })
                  .on(this.endEvent, function (t) {
                    e.$eventEl.trigger(a),
                      e.on_move_event_handle(t),
                      e.on_end_event_handle(t);
                  });
            }),
            (t.prototype.on_move_event_handle = function (t) {
              var e = this.$el.offset().left,
                i = t.clientX;
              if (!i) {
                if (
                  !(
                    t.originalEvent.touches &&
                    t.originalEvent.touches.length > 0
                  )
                )
                  return;
                i = t.originalEvent.touches[0].clientX;
              }
              var n = i - e - this.centerOfHandle;
              this.isRtl &&
                (n = this.$el.outerWidth() - n - this.centerOfHandle),
                this.set_position_left(n);
            }),
            (t.prototype.on_end_event_handle = function (t) {
              t.preventDefault(),
                o()(document).off(this.moveEvent).off(this.endEvent);
            }),
            (t.prototype.set_position_left = function (t, e, i) {
              void 0 === t && (t = this.positionLeft),
                void 0 === e && (e = !1),
                void 0 === i && (i = !1),
                (t = Math.min(Math.max(0, t), this.maxHandleLimitPositionLeft)),
                (this.config.value = e
                  ? this.lastValue
                  : this.get_value_by_position_left(t)),
                (this.positionLeft = t =
                  this.get_position_left_by_value(this.config.value)),
                (this.lastValue !== this.config.value || e) &&
                  ((this.lastValue = this.config.value),
                  this.$fill.css("width", t),
                  this.$handle.css(this.isRtl ? "right" : "left", t),
                  !e &&
                    this.$eventEl.trigger(r, [
                      this.config.value,
                      +(this.config.value / this.config.max).toFixed(4),
                      i,
                    ]));
            }),
            (t.prototype.update_rect = function () {
              (this.rangeRectWidth = this.$el.outerWidth()),
                (this.handleRectWidth = this.$handle.outerWidth()),
                (this.maxHandleLimitPositionLeft =
                  this.rangeRectWidth - this.handleRectWidth),
                (this.centerOfHandle = this.handleRectWidth / 2),
                (this.positionLeft = this.get_position_left_by_value(
                  this.config.value
                ));
            }),
            (t.prototype.get_position_left_by_value = function (t) {
              var e =
                (t - this.config.min) / (this.config.max - this.config.min);
              return isNaN(e) || e < 0
                ? 0
                : this.maxHandleLimitPositionLeft * e;
            }),
            (t.prototype.get_value_by_position_left = function (t) {
              var e = t / this.maxHandleLimitPositionLeft;
              return parseInt(
                this.config.step *
                  Math.round(
                    (e * (this.config.max - this.config.min)) / this.config.step
                  ) +
                  this.config.min +
                  ""
              );
            }),
            t
          );
        })();
      e.default = h;
    },
    function (t, e) {
      function i(t, e, i) {
        var n, o, s, r, l;
        function a() {
          var h = Date.now() - r;
          h < e && h >= 0
            ? (n = setTimeout(a, e - h))
            : ((n = null), i || ((l = t.apply(s, o)), (s = o = null)));
        }
        null == e && (e = 100);
        var h = function () {
          (s = this), (o = arguments), (r = Date.now());
          var h = i && !n;
          return (
            n || (n = setTimeout(a, e)),
            h && ((l = t.apply(s, o)), (s = o = null)),
            l
          );
        };
        return (
          (h.clear = function () {
            n && (clearTimeout(n), (n = null));
          }),
          (h.flush = function () {
            n &&
              ((l = t.apply(s, o)),
              (s = o = null),
              clearTimeout(n),
              (n = null));
          }),
          h
        );
      }
      (i.debounce = i), (t.exports = i);
    },
    function (t, e, i) {},
    ,
    ,
    ,
    ,
    ,
    ,
    ,
    function (t, e, i) {
      t.exports = i(1);
    },
  ]);
});
